/**
 * @generated SignedSource<<07991f0d1492885a4e9bbebeb87368bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ServiceType = "GROUP" | "SOLO";
import { FragmentRefs } from "relay-runtime";
export type ServiceEditForm_service$data = {
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly placeholder: string | null;
  readonly type: ServiceType | null;
  readonly " $fragmentType": "ServiceEditForm_service";
};
export type ServiceEditForm_service$key = {
  readonly " $data"?: ServiceEditForm_service$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceEditForm_service">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceEditForm_service",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Service",
  "abstractKey": null
};

(node as any).hash = "feb7beeb7c8e641f46b231fb946eb121";

export default node;
